var map = {
	"./avatar-img-icon.svg": "bcb7",
	"./blue-calendar-icon.svg": "24ac",
	"./blue-letter-icon.svg": "314c",
	"./blue-pencil-icon.svg": "2ef6",
	"./blue-people-icon.svg": "f3d9",
	"./blue-person-icon.svg": "7dbb",
	"./blue-squares-icon.svg": "ed07",
	"./blue-telefone-icon.svg": "d4e1",
	"./building-icon.svg": "a24c",
	"./calendar-gray-icon.svg": "ec67",
	"./calendar-icon.svg": "eb66",
	"./check-icon.svg": "1517",
	"./circle-people-icon.svg": "8f80",
	"./clock-icon.svg": "b7a3",
	"./clock-one-color-icon.svg": "7cb5",
	"./cloud-load-icon.svg": "8ed5",
	"./color-pencil-icon.svg": "0e37",
	"./company-icon.svg": "03ff",
	"./config-icon.svg": "3beb",
	"./delete-icon.svg": "322a",
	"./delete-red-icon.svg": "c1ed",
	"./desktop-icon.svg": "6c49",
	"./exclamation-icon.svg": "1392",
	"./family-icon.svg": "4a26",
	"./folder-icon.svg": "3517",
	"./gear-icon.svg": "7f17",
	"./group-icon.svg": "9150",
	"./head-brain-icon.svg": "06f6",
	"./interrogation-icon.svg": "8d18",
	"./lamp-icon.svg": "7c17",
	"./letter-icon.svg": "51b1",
	"./line-chart-icon.svg": "2b02",
	"./man-icon.svg": "130f",
	"./multiple-letter-icon.svg": "0789",
	"./not-icon.svg": "e46a",
	"./padlock-icon.svg": "762e",
	"./paper-icon.svg": "2d27",
	"./pencil-icon.svg": "76f1",
	"./people-icon.svg": "8128",
	"./search-icon.svg": "41e4",
	"./squares-icon.svg": "cfff",
	"./table-add-user-icon.svg": "db6d",
	"./table-edit-icon.svg": "833f",
	"./table-remove-user-icon.svg": "95f3",
	"./trash-icon.svg": "d6e2",
	"./video-icon.svg": "260f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "feed";